import styled from 'styled-components';

interface IContainer {
    hasResults: boolean;
    stickyTop: string;
}

export const Container = styled.div<IContainer>`
    height: ${({ hasResults }) => (hasResults ? `100%` : '500px')};
    min-width: 100%;
    transition: width 0.5s ease 0.3s;

    .ag-root,
    .ag-root-wrapper {
        overflow: unset !important;
    }

    .ag-header {
        position: sticky !important;
        z-index: 2 !important;
        top: ${(props) => props.stickyTop} !important;
    }

    .ag-center-cols-viewport {
        overflow: hidden !important;
    }

    .ag-row-selected {
        background-color: var(--grid-row-cell-focus-bg-color) !important;
    }

    .ag-overlay-wrapper {
        display: block;
    }
`;
